import { Component, inject } from '@angular/core';
import { ToastProvider } from './toast.provider';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [ToastComponent],
  template: `
    <div class="flex flex-col gap-2" data-testid="toast-container">
      @for (toast of toastProvider.toasts(); track toast.id) {
        <app-toast [toast]="toast" (close)="toastProvider.dismiss(toast.id)" />
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastProvider = inject(ToastProvider);
}
